const config = {
  baseUrl: 'https://th-api.dimorder.com',
  mpUrl: 'https://th-mp-order.dimorder.com',
}

export default config
